export const environment = {
    production: true,
    assetsPath: 'assets',
    apiUrl: 'https://dev.api.conedrive.com/ConeTools/PowermateAPI/api/',
    imgPathUrl:'https://dev.api.conedrive.com/ConeTools/',
    //apiUrl: 'https://conetools.com/PowermateAPI/api/',
    //imgPathUrl:'https://conetools.com/'
    apimSubscriptionKey: '0940246c2640494b89d733bfe2afbc21'
  };